import Vue from 'vue'
import Moment from 'moment'
import App from './App'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueNativeSock from 'vue-native-websocket'
import VueScrollTo from 'vue-scrollto'
import Config from './config.js'

Vue.use(BootstrapVue)
Vue.use(VueNativeSock, Config.ws_url, { 
	format: 'json',
	connectManually: true,
	reconnection: true,
})
Vue.use(VueScrollTo, {
	offset: -100,
	x: false,
	y: true,
})

Vue.config.productionTip = false
Vue.filter('formatTime', function(value) {
	return Moment.utc(value*1000).format('mm:ss');
});
Vue.filter('formatTimeHours', function(value) {
	var hours = Math.floor(value / 3600);
	value %= 3600;
	var minutes = Math.floor(value / 60);
	var seconds = Math.floor(value % 60);
	return hours + ':' + minutes + ':' + seconds;
});
Vue.filter('formatDate', function(value) {
	return Moment.unix(value).format('MMM Do HH:mm');
});

new Vue({
	el: '#app',
	components: { App },
	template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js